module.exports = __webpack_public_path__ + "img/logo.6b1e097a.png";